export const BULK_VALIDATE_SHOW = 'BULK_VALIDATE_SHOW';
export const BULK_VALIDATE_RESET = 'BULK_VALIDATE_RESET';
export const BULK_VALIDATE_IN_PROGRESS = 'BULK_VALIDATE_IN_PROGRESS';
export const BULK_VALIDATE_DONE = 'BULK_VALIDATE_DONE';
